<template>
  <page-layout layout="C">
    <!-- 搜索区域 -->
    <div class="layout-search">
      <div>知识库查看</div>
    </div>
    <!-- 功能按钮区域 -->
    <div class="layout-function">
    </div>
    <!-- 结果区域 -->
    <div class="layout-result">

      <!-- 分页区域 -->
    </div>
    <!-- hidden等dialog区域 -->
    <!-- 添加或修改对话框 -->

  </page-layout>
</template>
<script>
  export default {
    name: 'Temp',
    components: {},
    data() {
      return {};
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
</style>
